
import About from "./components/About";
import Alert from "./components/Alert";
import Navbar from "./components/Navbar";
import { Textform } from './components/Textform';
import React,{useState} from "react";
import {
  BrowserRouter as Router,
  Switch,
  Route,
  Link
} from "react-router-dom"


// <Textform  title='sanket coding hub' btn="click here" ()=>{props.tgl(null)} document.body.classlist.add(cls)/>

function App() {
  const [mode,setmode]=useState('light');
  const [alert,setalert]=useState(null);
  
  const [btncl,setbtncl]=useState("dark");

  let showalert=(message,type)=>{
    setalert({
      msg:message,
      type:type
    })
    setTimeout(() => {
      setalert(null)
    }, 1500);
  }

  const togglemode=(cls)=>{
    removebodyclasses()
    console.log(cls)
    
    if(mode==="light"){
      setmode("dark")
      document.body.style.backgroundColor='gray';
      showalert("Dark mode is Enabled","Success")
  
     
    }else{
      setmode("light")
      document.body.style.backgroundColor='white'
      showalert("Light Mode Is Enabled","Success")
    
    }
  }
  const removebodyclasses=()=>{
    document.body.classList.remove('bg-danger')
    document.body.classList.remove('bg-primary')
    document.body.classList.remove('bg-success')
    document.body.classList.remove('bg-dark')
  }
  const tggl=(cls)=>{
    removebodyclasses()
    console.log(cls)
    document.body.classList.add('bg-'+cls)
  if(mode==="light" || btncl==="dark"){  
    document.body.style.backgroundColor="orange";
    setmode("orange")
    setbtncl("red")
  }else{
    document.body.style.backgroundColor="white";
    setmode("light")
    setbtncl("dark")

  }
  }

  const apii=()=>{
    if(mode==='light'){
      setmode('orange');
      document.body.style.backgroundColor="orange"
    }
    else{
      setmode('light');
      document.body.style.backgroundColor="white"
    }
  }
  return (
<>
<Router>
<Navbar theme={mode} toggle={togglemode} tgl={tggl} nw={apii}/>
<Alert alert={alert}/>
<div className="container my-3">

{/*<Switch>
  <Route path="/about">
    <About/>
  </Route>
  <Route path="/users">
  <Textform btncl={tggl} all={showalert}/>
  </Route>
</Switch>*/}
<Textform btncl={tggl} all={showalert}  title={<h3>Welcome to My Text Editor</h3>}/>
<About mode={mode}/>
</div>
</Router>

{/*<About mode='hii'/>*/}
  

</>
  );
}

export default App;
